<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="courses"
          hide-actions
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">
              <v-layout row justify-center>
                  <v-btn
                    color="primary"
                    @click="getDatesToRate(props.item.id)"
                  >
                    Calificar</v-btn>
              </v-layout>
            </td>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Elegir fechas para calificar
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers_dates"
            :items="dates_to_select"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.start_date + ' - ' + props.item.end_date }}</td>
              <td class="text-xs-center">{{ props.item.course_start_date }}</td>
              <td>{{ $t(`extracurriculares.courses.registration_dates.status_text.${props.item.status}`) }}</td>
              <td class="text-xs-center">
                <v-layout row justify-center>
                  <v-flex xs2>
                    <v-btn
                      color="primary"
                      @click="rate(props.item.id)"
                    >{{ $t('extracurriculares.teachers_assistance.schedules_modal.select') }}</v-btn>
                  </v-flex>
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn color="primary" dark @click="dialog = false">
              {{ $t('close') }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="rate_dialog"
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card>
        <rate-view
          :date_id="date_id"
        >
        </rate-view>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import rateView from './rate'
  export default {
    name: 'teacher-course-rate-view',
    components: {
      'rate-view': rateView,
    },
    data() {
      return {
        courses: [],
        headers: [
          {
            text: this.$t('extracurriculares.teachers_assistance.table.course'),
            align: 'center',
            value: 'name'
          },
          {
            text: this.$t('extracurriculares.teachers_assistance.table.actions'),
            align: 'center',
            value: 'actions'
          }
        ],
        dialog: false,
        headers_dates: [
          {
            text: 'Fechas de registro',
            align: 'center',
            value: 'schedule'
          },
          {
            text: 'Fecha de inicio curso',
            align: 'center',
            value: 'schedule'
          },
          {
            text: 'Estado',
            align: 'center',
            value: 'schedule'
          },
          {
            text: this.$t('extracurriculares.teachers_assistance.table.actions'),
            align: 'center',
            value: 'actions'
          }
        ],
        dates_to_select: [],
        rate_dialog: false,
        date_id: 0
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/extracurriculares/teacher/courses')
          .then(resp => {
            const { data } = resp
            if (resp.status === 200) {

              this.courses = data.courses

            }
          })
          .catch(error => console.log(error))
      },
      getDatesToRate(course_id) {
        const course = this.courses.find(course => course.id === course_id)
        console.log(course)
        const registration_dates = course.registration_dates
        this.dates_to_select = registration_dates
        this.dialog = true
        console.log(registration_dates)
      },
      rate(date_id) {
        this.date_id = date_id
        this.rate_dialog = true
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/teacher/course_rate.vue